export type KeyboardInitialState = {
  isKeyboard: boolean
}

export const keyboardInitialState: KeyboardInitialState = {
  isKeyboard: false
}
